import { ArrowLeft } from "lucide-react";
import { getEdgeReportById, useQuery } from "wasp/client/operations";
import useTranslation from "../../../client/hooks/useTranslation";
import { Button } from "../../../client/components/ui/button";
import EdgeReportView from "../../../edgy/EdgeReportView";
import { edgeReportSchema } from "../../../edgy/reportSchema";
import { useLiteData } from "../../data/LiteDataProvider";
import { Card, cardCls, Empty } from "../../ui/ui";

type QaEntry = { question: string; answer: string; askedAt: string };

/**
 * Une analyse rouverte : le rapport rendu par le composant Advanced, puis la
 * discussion qui l'a suivi. Lecture seule, comme la page « Mes analyses ».
 */
export function ReportDetail({ id, onBack }: { id: string; onBack: () => void }) {
  const T = useTranslation();
  const t = T.edgy.history;
  const { fmt } = useLiteData();
  const { data: report, isLoading } = useQuery(getEdgeReportById, { id });

  const parsed = report?.report ? edgeReportSchema.safeParse(report.report) : null;
  const thread = (report?.qaThread as QaEntry[] | null) ?? [];

  return (
    <div className="space-y-4">
      <Button variant="ghost" size="sm" onClick={onBack} className="-ml-2">
        <ArrowLeft className="h-4 w-4 mr-1" />{t.back}
      </Button>

      {isLoading ? (
        <div className={cardCls}><Empty title={T.lite.common.loading} /></div>
      ) : parsed?.success && report ? (
        <>
          <section className={`${cardCls} p-4 md:p-6`}>
            <p className="text-sm text-muted-foreground mb-4">
              {t.analysedOn.replace("{date}", new Date(report.createdAt).toLocaleDateString(fmt.locale, { day: "numeric", month: "long", year: "numeric" }))}
            </p>
            <EdgeReportView report={parsed.data} />
          </section>

          {thread.length > 0 && (
            <Card title={t.conversation}>
              <div className="space-y-2">
                {thread.map((entry, i) => (
                  <div key={i} className="rounded-xl border border-border bg-muted/40 p-3">
                    <p className="text-sm font-medium">{entry.question}</p>
                    <p className="mt-1 text-sm text-muted-foreground">{entry.answer}</p>
                  </div>
                ))}
              </div>
            </Card>
          )}
        </>
      ) : (
        <div className={cardCls}><Empty title={T.edgy.errors.generic} /></div>
      )}
    </div>
  );
}
